import { all, takeLeading, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { retrieveFromLocalStorage, toCamelCase } from '../../utils/util';

import { requestRetrieveShortcuts, requestRetrieveAdminPings } from './system-user.actions';
import { getRetrieveShortcutsRequest, getRetrieveAdminPingsRequest } from './system-user.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setShortcuts } from '../../slices/user/user.slice';
import { setAdminPings } from '../../slices/party/party.slice';

export function* performRetrieveShortcutsRequest() {
  try {
    yield put(addSpinner('Retrieving Shortcuts'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const [endpoint, options] = getRetrieveShortcutsRequest(personExternalReference);

    const { data } = yield call(axios, endpoint, options);

    const shortcuts = {};

    data.homepageShortcutVOs.forEach((shortcut) => {
      shortcuts[toCamelCase(shortcut.name)] = shortcut.status;
    });

    yield put(setShortcuts(shortcuts));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving Shortcuts'));
  }
}

export function* watchRetrieveShortcutsRequest() {
  yield takeLeading(requestRetrieveShortcuts.type, performRetrieveShortcutsRequest);
}

export function* performRetrieveAdminPingsRequest() {
  try {
    yield put(addSpinner('Retrieving Admin Notifications'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const [endpoint, options] = getRetrieveAdminPingsRequest(personExternalReference);

    const { data } = yield call(axios, endpoint, options);
    delete data.message;

    yield put(setAdminPings(data));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving Admin Notifications'));
  }
}

export function* watchRetrieveAdminPingsRequest() {
  yield takeLeading(requestRetrieveAdminPings.type, performRetrieveAdminPingsRequest);
}

export default function* systemUserSaga() {
  yield all([watchRetrieveShortcutsRequest(), watchRetrieveAdminPingsRequest()]);
}
